import React, { useState, useEffect } from 'react'
import { Modal } from "antd";
import {
  FormWrapperInputComponent, StatusComponent,
} from "../../../../common/component/Index";
import Wrapper from '../../../../common/component/Wrapper';
import Input from "../../../../common/component/Input";
import TextArea from '../../../../common/component/TextArea';
import { cloneDeep, merge } from 'lodash'
import { capitalizeFirstLetter } from '../../../../../../helpers/functions';
import { ORDER } from '../../../../../../constants/Define';
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';
import { withTranslation } from "react-i18next";

const DetailStatusItem = ({
  title = '',
  visible = false,
  item = {},
  onSave = (data) => { },
  onClose = () => { },
  t,
  itemTypes = '',
  keyName = '',
  keyStatus = 'status'
}) => {

  const [status, setStatus] = useState(item[keyStatus])
  const [currStatus, setCurrStatus] = useState(null)

  const onSubmit = () => {
    if(ORDER.ACCEPT_STATUS_ITEM[itemTypes][currStatus]) {
      const data = cloneDeep(item);
      return onSave(merge(data, {
        [keyStatus]: status
      }), keyStatus)
    }
    onClose()
  }

  useEffect(() => {
    if (item) {
      setStatus(item[keyStatus])
      setCurrStatus(item[keyStatus])
    }
  }, [item])

  return (
    <Modal
      title={title}
      visible={visible}
      onOk={() => onSubmit()}
      onCancel={onClose}
      okText={t('action.save')}
      cancelText={t('action.cancel')}
      destroyOnClose={true}
    >

      <Wrapper className='col-md-12'>
        <Wrapper>
          {item[keyName]}
        </Wrapper>
        <Wrapper>
        <FormWrapperInputComponent
            labelTitle={capitalizeFirstLetter(t(`item.order.tourStatus`))}
          >
            {status && (ORDER.ACCEPT_STATUS_ITEM[itemTypes][currStatus]) ? 
                <AntSelect className="select-enum"
                showArrow
                placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t(`item.order.tourStatus`)).toLowerCase())}
                value={t(`item.order.orderItemStatus.${status}`)}
                onChange={setStatus}
                style={{ width: '100%' }}
                >
                <AntOption key={currStatus} value={currStatus}>{`${t(`item.order.orderItemStatus.${currStatus}`)} (${t('item.order.currentStatus')})`}</AntOption>
                {(ORDER.ORDER_ITEM_STATUS).map(item => 
                    currStatus && ORDER.ACCEPT_STATUS_ITEM[itemTypes][currStatus].includes(item) && <AntOption key={item} value={item}>{t(`item.order.orderItemStatus.${item}`)}</AntOption>
                )}
                </AntSelect>
                : 
                <p><StatusComponent color={t(`item.order.orderItemStatusColor.${currStatus}`)}
                label={t(`item.order.orderItemStatus.${currStatus}`)} /></p>
            }
          </FormWrapperInputComponent>

        </Wrapper>
      </Wrapper>
    </Modal>
  )
}

export default withTranslation()(DetailStatusItem);